// Address.vue
<template>

  <div class="card">
    <div class="card-header">

      {{ title }}
      <a v-if="title === 'Shipping Address'" class="float-right font-weight-light" @click="copyBilling" href="#">Copy
        From Billing</a>
    </div>

    <div class="card-body">
      <div class="mb-3">
        <label for="company">Company*</label>
        <b-form-input name="company" v-model="localAddress.company"
                      :state="this.$parent.$data.highlightMissingFields && !!localAddress.company"
        ></b-form-input>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="firstName">First Name*</label>
          <b-form-input name="fname" v-model="localAddress.fname"
                        :state="this.$parent.$data.highlightMissingFields && !!localAddress.fname"
          ></b-form-input>
        </div>
        <div class="col-md-6 mb-3">
          <label for="lastName">Last Name* </label>
          <b-form-input name="lname" v-model="localAddress.lname"
                        :state="this.$parent.$data.highlightMissingFields && !!localAddress.lname"></b-form-input>
        </div>
      </div>

      <div class="mb-3">
        <label for="address">Address* </label>
        <b-form-input name="address" v-model="localAddress.address"
                      :state="this.$parent.$data.highlightMissingFields && !!localAddress.address"></b-form-input>
      </div>
      <div class="mb-3">
        <label for="address2">Address 2 (optional)</label>
        <b-form-input name="address2" v-model="localAddress.address2"></b-form-input>
      </div>
      <div class="row">
        <div class="mb-3"
             v-bind:class="{'col-md-12': localAddress.country !== 'GB', 'col-md-6': localAddress.country === 'GB'}">
          <label for="city">City* </label>
          <b-form-input name="city" v-model="localAddress.city"
                        :state="this.$parent.$data.highlightMissingFields && !!localAddress.city"></b-form-input>
        </div>
        <div class="col-md-7 mb-3" v-if="localAddress.country !== 'GB'">
          <label v-if="localAddress.country === 'US'">State* </label>
          <label v-else-if="localAddress.country === 'CA'">Province* </label>
          <label v-else-if="localAddress.country !== 'GB'">State/Province </label>

          <b-form-select v-if="localAddress.country === 'US'" v-model="localAddress.state"
                         :state="this.$parent.$data.highlightMissingFields && !!localAddress.state">
            <option></option>
            <option v-for="state in $parent.productdata.states['us']" :value="state" :key="state">{{ state }}</option>
          </b-form-select>

          <b-form-select v-if="localAddress.country === 'CA'" v-model="localAddress.state"
                         :state="this.$parent.$data.highlightMissingFields && !!localAddress.state">
            <option></option>
            <option v-for="state in $parent.productdata.states['ca']" :value="state" :key="state">{{ state }}</option>
          </b-form-select>

          <b-form-input v-if="localAddress.country === 'GB'" name="state"
                        v-model="localAddress.state"></b-form-input>
        </div>
        <div class="mb-3"
             v-bind:class="{'col-md-5': localAddress.country !== 'GB', 'col-md-6': localAddress.country === 'GB'}">
          <label for="zip">{{ $parent.productdata.zipText }}*</label>
          <b-form-input name="zip" v-model="localAddress.zip"
                        :state="this.$parent.$data.highlightMissingFields && !!localAddress.zip"></b-form-input>
        </div>
      </div>

      <div class="mb-3">
        <label for="country">Country* </label>
        <b-form-select name="country" v-model="localAddress.country"
                       :state="this.$parent.$data.highlightMissingFields && !!localAddress.country">
          <option></option>
          <option v-for="country in $parent.productdata.countries" :value="country.code" :key="country.code">
            {{ country.name }}
          </option>
        </b-form-select>
      </div>

      <div class="mb-3">
        <label for="phone">Phone*</label>
        <b-form-input name="phone" v-model="localAddress.phone" v-mask="['(###)-###-####', '+# (###) ###-####', '+## ### ###-####']" masked="true"
                      :state="this.$parent.$data.highlightMissingFields && !!localAddress.phone"></b-form-input>
      </div>
      <div class="mb-3">
        <label for="email">Email*</label>
        <b-form-input name="email" v-model="localAddress.email"
                      :state="this.$parent.$data.highlightMissingFields && validEmail"></b-form-input>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  props: {
    title: String,
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    localAddress: {
      get() {
        return this.value
      },
      set(localAddress) {
        this.$emit('input', localAddress)
      }
    },
    validEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.localAddress.email);
    }
  },
  methods: {
    copyBilling() {
      for (let key in this.$parent.billAddress) {
        if (this.$parent.billAddress.hasOwnProperty(key)) {
          this.localAddress[key] = this.$parent.billAddress[key];
        }
      }
    }
  }
}
</script>
